/* eslint-disable no-mixed-operators */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint react/jsx-pascal-case: 0 */
import * as React from 'react';
import { connect } from 'react-redux';
import Constants from '../../../../core/libraries/Constants';
import { IUserProfile } from '../../../Auth/types';
import { confirmDialog } from '../../../Dialog/actions';
import RbLoadingSpinner from '../../../../bosch-react/components/loading-spinner/RbLoadingSpinner';
import AdminWrapper from '../../AdminWrapper';
import RbLabel, { LabelSize } from '../../../../bosch-react/components/label/RbLabel';
import { RootState } from '../../../../store/store';
import { withRouter } from 'react-router-dom';
import RbTabs, { IRbTabItem } from '../../../../bosch-react/components/tabs/RbTabs';
import LoadingDialog from '../../../../core/components/LoadingDialog';
// const Statistic_Search = React.lazy(() => import('./Statistic_Search'));
const Statistic_Report = React.lazy(() => import('./Statistic_Report'));

interface StatisticsProps {
    userProfile: IUserProfile | undefined,
    confirmDialog: typeof confirmDialog,
    history: any,
}

class Statistics extends React.Component<StatisticsProps, any> {


    handleProfileChanged() {
        const { userProfile } = this.props
        if (!!userProfile) {
            if (userProfile.permissions?.isAdmin===false) {
                this.props.confirmDialog(
                    Constants.CONFIRMATION_MESSAGE.NO_PERMISSION.TITLE,
                    Constants.CONFIRMATION_MESSAGE.NO_PERMISSION.CONTENT,
                    true,
                    () => {
                        window.location.href = process.env.REACT_APP_HOME!;
                    }
                );
            }
        }
    }

    async componentDidMount() {
        await this.handleProfileChanged();
    }

    async componentDidUpdate(prevProps: Readonly<StatisticsProps>, prevState: Readonly<any>, snapshot?: any) {
        if (prevProps.userProfile !== this.props.userProfile) {
            await this.handleProfileChanged();
        }
    }

    render() {
        let element: any = "";
        const items: IRbTabItem[] = [
            {
                label: "Power BI",
                content: (
                    <React.Suspense fallback={
                        <div className="ms-Grid">
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12" style={{ textAlign: "center", paddingTop: "35vh" }}>
                                    <RbLoadingSpinner size="1.5" />
                                </div>
                            </div>
                        </div>
                    }>
                        <div className="ms-Grid">
                            <div className="ms-Grid-row">
                                <iframe style={{ width: "100%", minHeight: "80vh", overflow: "auto" }} src="https://app.powerbi.com/reportEmbed?reportId=1e0d5e9f-59aa-441c-abc2-c10e243dbc3b&autoAuth=true&ctid=0ae51e19-07c8-4e4b-bb6d-648ee58410f4&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLW5vcnRoLWV1cm9wZS1sLXByaW1hcnktcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D" allowFullScreen></iframe>
                            </div>
                        </div>
                    </React.Suspense>
                )
            },
            {
                label: "Export data to excel",
                content: (
                    <React.Suspense fallback={
                        <div className="ms-Grid">
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12" style={{ textAlign: "center", paddingTop: "35vh" }}>
                                    <RbLoadingSpinner size="1.5" />
                                </div>
                            </div>
                        </div>
                    }>
                        <Statistic_Report></Statistic_Report>
                    </React.Suspense>
                )
            }
        ];
        if (this.props.userProfile?.permissions?.checkHasPermission([Constants.PERMISSIONS.SUPER_ADMIN])) {

            element = (
                <AdminWrapper history={this.props.history}>
                    <div className="ms-Grid">
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm1" />
                            <div className="ms-Grid-col ms-sm10">
                                <div className="ms-Grid">
                                    <div className="ms-Grid-row">
                                        <RbLabel className="header-title" size={LabelSize.Large}>Statistics</RbLabel>
                                    </div>
                                    <div className="ms-Grid-row">
                                        <RbTabs items={items} />
                                    </div>
                                </div>
                            </div>
                            <div className="ms-Grid-col ms-sm1" />
                        </div>
                    </div>
                </AdminWrapper>
            );
        }
        else {
            if (this.props.userProfile?.permissions?.checkHasPermission([Constants.PERMISSIONS.ADMIN])) {

                element = (
                    <AdminWrapper history={this.props.history}>
                        <div className="ms-Grid">
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm1" />
                                <div className="ms-Grid-col ms-sm10">

                                    <div className="ms-Grid">
                                        <div className="ms-Grid-row">
                                            <RbLabel className="header-title" size={LabelSize.Large}>Statistics</RbLabel>
                                        </div>
                                        <div className="ms-Grid-row">
                                            <RbTabs items={[items[0]]} />
                                        </div>

                                    </div>

                                </div>
                                <div className="ms-Grid-col ms-sm1" />
                            </div>
                        </div>
                    </AdminWrapper>
                );
            }
        }

        return !!this.props.userProfile && element || <LoadingDialog />;
    }
}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile
});

export default withRouter(connect(mapStateToProps, { confirmDialog })(Statistics));